import { captureException } from "@stadium/services/error-reporting";

export class ReportedError extends Error {
  constructor(error: Error, options?: { type: string; data: any }) {
    super(error.message);
    this.name ||= "Error";
    const { type = this.name } = options || {};

    captureException(this, {
      tags: { type },
      extra: { error, ...(options?.data && { data: options.data }) },
    });
  }
}

/** @deprecated Use ReportedError */
export class SentryError extends ReportedError {}

export class StoreNumberMismatchError extends ReportedError {
  get name() {
    return "Store Number Mismatch";
  }
}

export class StoreCodeMismatchError extends ReportedError {
  get name() {
    return "Store Code Mismatch";
  }
}

export class PaymentError extends ReportedError {
  get name() {
    return "Payment Error";
  }
}

export class AuthError extends ReportedError {
  get name() {
    return "Auth Error";
  }
}

export class OrderActionError extends ReportedError {
  get name() {
    return "Order Action Error";
  }
}

export class MaxUpdateDepthError extends ReportedError {
  get name() {
    return "Maximum Update Depth Error";
  }
}

export class LaunchDarklyError extends ReportedError {
  get name() {
    return "LaunchDarkly Error";
  }
}

export {
  DEFAULT_MONITORING_DOMAINS,
  getMonitoringWhitelistUrl,
  getMonitoringWhitelistUrls,
  getDefaultAllowedTracingUrls,
} from "./monitoring-urls";

/** @deprecated Use getMonitoringWhitelistUrl */
export { getMonitoringWhitelistUrl as getSentryWhitelistUrl } from "./monitoring-urls";

export class AssetUploadError extends ReportedError {
  get name() {
    return "Asset upload error";
  }
}
